import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { RuleService } from '@app/shared/services/rule/rule.service';
import { TitleService } from '@app/shared/services/title/title.service';
import { DialogDeleteRulesetComponent } from '../../components/dialog-delete-ruleset/dialog-delete-ruleset.component';

@Component({
  standalone: false,
  selector: 'sbnb-canned-response-detail',
  templateUrl: './canned-response-detail.component.html',
  styleUrls: ['./canned-response-detail.component.scss'],
})
export class CannedResponseDetailComponent implements OnInit {
  ruleSetId: any;
  ruleSetData: any;
  loading: boolean;
  saveStatus: number;
  lastSaved: Date;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private ruleSetService: RuleService,
    private dialog: MatDialog,
    private router: Router,
    private titleService: TitleService
  ) {}

  ngOnInit() {
    this.titleService.manuallySet('Canned response');
    this.loading = true;

    this.route.params.subscribe((params) => {
      this.ruleSetId = params['id'];
      this.ruleSetService.getRuleSetById(this.ruleSetId).subscribe((res) => {
        this.ruleSetData = res.data;
        this.titleService.manuallySet(this.ruleSetData.name);
        this.loading = false;
      });
    });
  }

  goBack() {
    this.router.navigate(['/gx/canned-responses']);
  }

  updateRuleSet() {
    this.saveStatus = 1;

    this.ruleSetService.updateRuleSet(this.ruleSetId, this.ruleSetData).subscribe((res: any) => {
      if (res.error) {
        this.saveStatus = -1;
      } else {
        this.saveStatus = 2;
        this.lastSaved = new Date();
        setTimeout(() => {
          this.saveStatus = null;
        }, 2000);
      }
    });
  }

  deleteRulesetPrompt() {
    const dialogRef = this.dialog.open(DialogDeleteRulesetComponent, {
      width: '720px',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteRuleset();
      }
    });
  }

  deleteRuleset() {
    this.ruleSetService.deleteRuleset(this.ruleSetId).subscribe((res) => {
      this.location.back();
    });
  }

  ruleSaveStatusChange($event) {
    this.saveStatus = $event;

    if ($event === 2) {
      this.lastSaved = new Date();
      setTimeout(() => {
        this.saveStatus = null;
      }, 2000);
    }
  }

  copyRuleset() {
    this.ruleSetService.copyRuleset(this.ruleSetId).subscribe((res) => {
      if (res.data.id) {
        this.router.navigate(['/gx/canned-responses/resp/', res.data.id]);
      }
    });
  }

  handleScopeChange(event) {
    this.ruleSetData.all_platforms = event.all_platforms;
    this.ruleSetData.all_hosts = event.all_hosts;
    this.ruleSetData.all_properties = event.all_properties;
    this.ruleSetData.properties = event.properties;
    this.ruleSetData.hosts = event.hosts;
    this.ruleSetData.platforms = event.platforms;

    this.updateRuleSet();
  }
}
